import { render, staticRenderFns } from "./strategyAdmin.vue?vue&type=template&id=f5c5bf72&scoped=true"
import script from "./strategyAdmin.vue?vue&type=script&lang=js"
export * from "./strategyAdmin.vue?vue&type=script&lang=js"
import style0 from "./strategyAdmin.vue?vue&type=style&index=0&id=f5c5bf72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c5bf72",
  null
  
)

export default component.exports